/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface WorkerControllerGetVideoUrl$Params {
  jobUuid: string;
}

export function workerControllerGetVideoUrl(http: HttpClient, rootUrl: string, params: WorkerControllerGetVideoUrl$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, workerControllerGetVideoUrl.PATH, 'get');
  if (params) {
    rb.path('jobUuid', params.jobUuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

workerControllerGetVideoUrl.PATH = '/worker/jobs/{jobUuid}/video-url';
